import { defineAction } from '~/prix'
import { z } from 'zod'
import creditBracketDeleteAction from './creditBracketDelete.action.json' with { type: 'json' }
import { creditBracketObject } from '../creditBracketObject'

const creditBracketDeleteDefinition = defineAction({
  ...creditBracketDeleteAction,

  input: z.object({ id: creditBracketObject.shape.id }),
  output: z.object({}),
})

export default creditBracketDeleteDefinition

